var app = new function(){
    this.modules = {};
    this.variables = {};

    this.start = function(){
        this.variables.maxWidth = 1260;
        this.variables.breakTablet = 992;
        this.variables.breakMobile = 767;
        this.variables.breakSmall = 360;

        /* Needs to be executed first. Pageloader will be calling the init() Function of app */
        this.modules.pageLoader.init();
    },
    this.init = function(){
        var proto = this;
        $.each(this.modules, function(index, element){
            if(typeof element.init === 'function' && element != proto.modules.pageLoader)
                element.init();
        });
        if(!Modernizr.touch && window.innerWidth<1024){
            $('a').addClass('no-touch');
        };
    };
};



$(function(){
    app.start();
});

function Lightbox() {
};

Lightbox.prototype = {
    constructor: Lightbox,

    lightbox: $(".lightbox"),

    elements: null,

    img: {},

    init: function() {
        var proto = this;
        this.lightbox.click(function(e){
            e.preventDefault();
            proto.closeLightbox();
            return false;
        });
        $(window).resize(function(){
            proto.calcImgHeight();
        });
    },
    clearLightbox: function() {
        if(this.elements != null){
            this.elements.unbind("click");
        }
    },
    closeLightbox: function () {
        var proto = this;
        proto.lightbox.velocity({opacity: 0},300,function(){
            proto.lightbox.css("display","none");
            proto.resetLightbox();
        });
    },
    resetLightbox: function () {
        this.lightbox.css("display","none").css("opacity",0);
        this.lightbox.find(".lightbox__progress").css("opacity",1).css("display","block");
        this.lightbox.find(".lightbox__img").html("");
    },
    initLightbox: function (selector) {
        var proto = this;
        proto.clearLightbox();
        this.elements = $(selector);
        this.elements.click(function(){
            proto.lightbox.css("display","block");
            proto.lightbox.velocity({opacity: 1},300,function(){});

            var img = $("<img />").attr('src', $(this).data("img"))
                .on('load', function() {
                    if (!this.complete || typeof this.naturalWidth == "undefined" || this.naturalWidth == 0) {
                        console.log('broken image!');
                        proto.closeLightbox();
                    } else {
                        proto.addImage(img);
                    }
                });
        });
    },
    addImage: function(img){
        var proto = this;
        proto.lightbox.find(".lightbox__progress").velocity({opacity: 0},300,function(){
            proto.lightbox.find(".lightbox__progress").css("display","none");
        });
        proto.lightbox.find(".lightbox__img").append(img);

        proto.img.width = img.width();
        proto.img.height = img.height();

        proto.calcImgHeight();

    },
    calcImgHeight: function(){
        var proto = this;
        if(this.lightbox.find(".lightbox__img img").length > 0) {
            var img = proto.lightbox.find(".lightbox__img img");
            if (proto.img.width > proto.img.height) {
                if (img.width() >= proto.lightbox.find(".lightbox__img").width()) {
                    img.width("100%");
                    img.height("auto");
                }
            }
            if (img.height() >= proto.lightbox.find(".lightbox__img").height()) {
                img.height(proto.lightbox.find(".lightbox__img").height());
                img.width("auto");
            }
            if(img.width() > $(window).width()){
                img.width("100%");
                img.height("auto");
            }
            var margin = proto.calcMargin(img);
            if(margin > 0){
                img.css("margin-top",margin);
            }
        }
    },
    calcMargin: function(img){
        return this.lightbox.find(".lightbox__img").height() / 2 - img.height() / 2 - 25;
    }
};

app.modules.lightbox = new Lightbox;
function Gmaps() {
};

Gmaps.prototype = {
    constructor: Gmaps,

    init: function(){
        var map;
        var bounds = new google.maps.LatLngBounds();
        var mapOptions = {
            mapTypeId: 'roadmap',
            disableDefaultUI: true,
            zoomControl: true,
            scrollwheel: false,
            draggable: false,
            styles: [{"featureType":"landscape","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","stylers":[{"saturation":-100},{"lightness":51},{"visibility":"simplified"}]},{"featureType":"road.highway","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"road.arterial","stylers":[{"saturation":-100},{"lightness":30},{"visibility":"on"}]},{"featureType":"road.local","stylers":[{"saturation":-100},{"lightness":40},{"visibility":"on"}]},{"featureType":"transit","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"administrative.province","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":-25},{"saturation":-100}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]}]
        };

        // Display a map on the page
        map = new google.maps.Map(document.getElementById("map_canvas"), mapOptions);
        map.setTilt(45);

        // Multiple Markers
        var mapdata = $("#coordinates");
        var markers = [];
        if(mapdata.length){
            markers = [
                [mapdata.attr("data-desc"), mapdata.attr("data-lat"), mapdata.attr("data-lon")]
            ];
        }
        else {
            markers = [
                ['Projektplanung Blüml GmbH & Co. KG, Deutschland', 48.062141, 12.767079]
            ];
        }

        // Info Window Content
        var infoWindowContent = [
            ['<div class="info_content"></div>']
        ];

        // Display multiple markers on a map
        var infoWindow = new google.maps.InfoWindow(), marker, i;

        // Loop through our array of markers & place each one on the map
        for( i = 0; i < markers.length; i++ ) {
            var position = new google.maps.LatLng(markers[i][1], markers[i][2]);
            bounds.extend(position);
            marker = new google.maps.Marker({
                position: position,
                map: map,
                title: markers[i][0],
                icon: '/assets/projekt-blueml.de/web/img/cursor.png'
            });

            // Allow each marker to have an info window
            google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {
                    //infoWindow.setContent(infoWindowContent[i][0]);
                    //infoWindow.open(map, marker);
                    var win = window.open("https://www.google.fr/maps/place/48%C2%B003'43.7%22N+12%C2%B046'01.5%22E/@48.0619085,12.7662436,17z/data=!4m2!3m1!1s0x0:0x0", '_blank');
                    win.focus();
                }
            })(marker, i));
            // Automatically center the map fitting all markers on the screen
            map.fitBounds(bounds);
        }

        // Override our map zoom level once our fitBounds function runs (Make sure it only runs once)
        var boundsListener = google.maps.event.addListener((map), 'bounds_changed', function(event) {
            this.setZoom(15);
            google.maps.event.removeListener(boundsListener);
        });
    }

};

app.modules.gmaps = new Gmaps;

function Navigation() {
};

Navigation.prototype = {
    constructor: Navigation,

    menuOpen: false,

    isAnimating: false,

    animationDelay: 300,

    init: function() {
        var proto = this;
        //$(".header__menu, .header__head__inner").css("opacity",1);
        proto.placeHamburger();
        $(window).resize(proto.placeHamburger);
        $(".header__menu, .header__head__inner").css("opacity",1);
        //$(".header__menu, .header__head__inner").velocity({opacity:1}, 300,function(){console.log("shown")});


        //Init events
        var it = this; //Take care to stay in the object and not change the 'this' to the menu button
        $('.header__menu').on('click touchstart', function(e){
            e.preventDefault();
            it.toggleMenu();
        });

        $("*[data-nav]").on('click touchstart',function(e){
            e.preventDefault();
            it.goTo($(this).attr("data-nav"));
        });
        $("*[data-project]").on('click touchstart',function(e){
            e.preventDefault();
            app.modules.pageLoader.goToProject($(this).attr("data-project"));
        });
    },

    placeHamburger: function() {
        var offset = $(".header__head__inner").offset().left;
        $(".header__menu").css("right",offset);
    },

    openMenu: function(){

        if(this.isAnimating)
            return false;

        this.isAnimating=true;
        this.menuOpen=true;

        var it = this;
        var nav = $('.navigation');

        $('.header__menu').addClass('header__menu--open');
        $('.header__head').addClass('header__head--fixed');
        nav.removeClass('hidden');
        var elems = nav.find('li,h2');
        elems.css('opacity', '0');

        nav.velocity({ opacity:1 }, this.animationDelay, function() {
            elems.each(function(i){
                $(this).delay(i*20).velocity({opacity:1}, 300,function(){
                    it.isAnimating=false;
                });
            });
        });
    },

    closeMenu: function(){

        if(this.isAnimating)
            return false;

        this.isAnimating=true;
        this.menuOpen=false;

        var it = this;
        var nav = $('.navigation');

        nav.velocity({ opacity:0 }, this.animationDelay, function() {

            it.isAnimating=false;
            $('.header__head').removeClass('header__head--fixed');
            $('.header__menu').removeClass('header__menu--open');
            nav.addClass('hidden');
        });
    },

    toggleMenu: function(option){
        if(this.menuOpen){
            this.closeMenu();
        }else{
            if(option == "projects"){
                $(".navigation__main").removeClass("show-mobile");
                $(".navigation__projects").addClass("show-mobile");
            }
            else {
                $(".navigation__main").addClass("show-mobile");
                $(".navigation__projects").removeClass("show-mobile");
            }
            this.openMenu();
        }
    },

    goTo: function(index){

        if(this.menuOpen)
            this.closeMenu();

        var page = $('.page--'+index);

        var pos = page.offset().top - 40;
        $("html, body").animate({ scrollTop: pos }, 600);

        var link;
        switch(index){
            case "philosophie":
                link = "/de/";
                break;
            case "services":
                link = "/de/leistungen";
                break;
            case "team":
                link = "/de/team";
                break;
            case "projects":
                link = "/de/projekte";
                break;
            case "blog":
                link = "/de/blog";
                break;
            case "contact":
                link = "/de/kontakt";
                break;
        }
        history.pushState(null,"Bl�ml",link);
    }
};

app.modules.navigation = new Navigation;

function Services() {
};

Services.prototype = {
    constructor: Services,

    isAnimating: false,

    animationDelay: 300,

    init: function(){
        //Init events
        var it = this; //Take care to stay in the object and not change the 'this' to the menu button
        $('.services__nav .swiper-slide a').on('click', function(e){

            e.preventDefault();

            if(!$(this).hasClass("services__nav--active"))
            {
                $('.services__nav .swiper-slide a').removeClass("services__nav--active");
                $(this).addClass("services__nav--active");
                it.changeTab(this.getAttribute("data-tab"));
            }
        });
        it.calcLinkWidth();
        $(window).resize(it.calcLinkWidth);

        //Init the first tab as active one
        var tabs = $(".service-tab");
        tabs.addClass("hidden");
        tabs.first().removeClass("hidden");
        $('.services__nav  a').first().addClass("services__nav--active");

       this.initSwiper();

    },
    calcLinkWidth: function(){
        $('.services__nav .swiper-slide').each(function(){
            var linkWidth = $(this).find("a").width();
            $(this).width(linkWidth);
        });
    },
    initSwiper: function() {

        var swiper = new Swiper('.services__swiper', {
            nextButton: '.services__nav .swiper-button-next',
            prevButton: '.services__nav .swiper-button-prev',
            slidesPerView: "auto",
            spaceBetween: 60
        });
    },
    changeTab: function(index){

        var it = this;

        var tabs = $(".service-tab");

        var tab = $(".service-tab--"+index);

        tabs.stop();
        tab.stop();

        //Closing tabs

        tabs.velocity({ opacity:0, left:"50px" }, this.animationDelay, function() {
            tabs.addClass("hidden");

            //Opening the tab
            tab.removeClass("hidden");
            tab.velocity({ opacity:1, left:0 }, this.animationDelay, function() {



            });

        });
    }

};

app.modules.services = new Services;

function Footer() {
};

Footer.prototype = {
    constructor: Footer,

    footerOpen: 0,

    init: function(){
        this.render();
        $(window).resize(this.render);
    },

    render: function() {

        var proto = this;

        $(".footer__nav a").on('click touchstart',function (e) {
            e.preventDefault();
            if(proto.footerOpen == $(this).data("link")){
                proto.closeFooter($(this));
            } else if(proto.footerOpen == 0) {
                proto.openFooter($(this));
            }
            else {
                var articleNo = $(this).data('link');
                proto.showRightArticle(articleNo);
                var footer = $(this).closest("#footer");
                footer.velocity('scroll',{
                    duration: 200
                });
                proto.footerOpen = articleNo;
            }
        });
    },
    closeFooter: function(button){
        var self = this;
        var footer = button.closest("#footer");
        var articleNo = button.data('link');
        var footerArticle = footer.find('.footer__tab[data-link="' + articleNo + '"]');
        footerArticle.velocity('slideUp',{
            duration: 200,
            complete: function(){
                footer.removeClass("is-opened");
            }
        });
        $('.footer__nav a').removeClass("nav-active");
        this.footerOpen = 0;
    },
    openFooter: function(button) {
        var self = this;
        var footer = button.closest("#footer");

        var articleNo = button.data('link');
        var footerArticle = footer.find('.footer__tab[data-link="' + articleNo + '"]');
        this.showRightArticle(articleNo);

        footer.addClass("is-opened");
        footerArticle.velocity('slideDown',{
            duration: 200,
            complete: function(){
            }
        });
        footer.velocity('scroll',{
            duration: 200
        });
        this.footerOpen = button.data("link");
    },
    showRightArticle: function(articleNo) {
        var rightArticle = $('.footer__tab[data-link="' + articleNo + '"]');
        var otherArticles = rightArticle.siblings(".footer__tab");
        otherArticles.hide();
        rightArticle.show();
        $('.footer__nav a').removeClass("nav-active");
        $('.footer__nav a[data-link="' + articleNo + '"]').addClass("nav-active");
    }
};

app.modules.footer = new Footer;

Detectizr.detect({detectScreen:false});

function Projects() {
};

Projects.prototype = {
    constructor: Projects,

    swiper: null,

    init: function() {
        var proto = this;
        if(!Modernizr.touch) {
            $(window).resize(function () {
                if (this.swiper != null) {
                    this.swiper.destroy(true, false);
                    proto.initSwiper();
                }
            });
        }

        if($("html.safari").length){

            setTimeout(function(){
                $(".projects__next").trigger("click");
                setTimeout(function(){
                    $(".projects__prev").trigger("click");
                },600);
            }, 200);
            
        }

    },
    initTabs: function() {
        var proto = this;
        var project = $("#section_projects");
        var before = project.find(".project input[name='projects_before']").val();
        var before_title = project.find(".project input[name='projects_before']").attr("data-title");
        var next = project.find(".project input[name='projects_next']").val();
        var next_title = project.find(".project input[name='projects_next']").attr("data-title");
        var count = project.find(".project input[name='projects_count']").val();
        var amount = project.find(".project input[name='projects_amount']").val();
        project.find(".projects__prev").unbind("click").click(function(){
            proto.loadProject(before);
        }).find("span").text(before_title);
        project.find(".projects__next").unbind("click").click(function(){
            proto.loadProject(next);
        }).find("span").text(next_title);
        project.find(".projects__number p").text(count+"/"+amount);

        proto.initSwiper();

        app.modules.lightbox.initLightbox(".project__gallery .swiper-slide");
        $("#section_projects .projects__number a").click(function(e){ e.preventDefault(); app.modules.navigation.toggleMenu('projects'); });
    },
    loadProject: function(friendlyurl){
        var proto = this;

        var project = $(".project");

        $(".projects__number a").addClass("turnInfinite");

        project.velocity({ opacity:0, left:"50px" }, 300, function() {

            $.ajax({
                method: "POST",
                url: "/de/projekte/" + friendlyurl,
                data: {call: true}
            })
                .done(function (html) {
                    $("#section_projects .project").html(html);
                    proto.initTabs();

                    app.modules.lightbox.initLightbox(".project__gallery .swiper-slide");
                    project.velocity({ opacity:1, left: 0 }, 300, function() {
                        $(".projects__number a").removeClass("turnInfinite");
                    });

                });
        });
    },
    initSwiper: function() {
        var proto = this;

        // The deferreds don't work on iPhone (iOS9 - Safari & Chrome)
        if(Modernizr.touch){
            proto.loadSwiper();
            console.log("loadedSwiperTouch");
        }
        else {
            console.log("notTouch");
            /*
            To calculate the container-size, the images must be loaded. $.when executes, when all images are loaded.
             */
            var imagesLoaded = [];

            $(".project__gallery .swiper-slide").each(function(){
                var img = $(this).find("img")[0];

                var dfd = $.Deferred();
                imagesLoaded.push(dfd);
                img.onload = function(){dfd.resolve();};
                img.src = img.src;
                console.log(dfd);
            });
            console.log(imagesLoaded);
            $.when.apply($, imagesLoaded).then(function () {
                console.log("inWhenFunction");
                $(".project__gallery .swiper-slide").each(function () {
                    var img = $(this).find("img")[0];

                    // Has to be done twice
                    $(this).width(img.width);
                    $(this).width(img.width);
                }, function () {
                    proto.loadSwiper();
                    console.log("loadedSwiperFirst");
                });
                proto.loadSwiper();
                console.log("loadedSliderApply");
            });
        }

    },
    loadSwiper: function() {
        console.log("loadSwiper");
        var len = $(".project .swiper-slide").length;

        if (len == 0) {
            $(".project__gallery").css("display", "none");
        }
        else {
            $(".project__gallery").css("display", "block");
        }


        var loop = false;
        if (len >= 3) {
            loop = true;
        }

        this.swiper = new Swiper('.project__gallery', {
            nextButton: '.project__abs .swiper-button-next',
            prevButton: '.project__abs .swiper-button-prev',
            slidesPerView: "auto",
            loopAdditionalSlides: 3,
            freeMode: true,
            loop: loop,
            spaceBetween: 30
        });

        console.log("slider initialized");

        
    }
};

app.modules.projects = new Projects;


function Team() {
};

Team.prototype = {
    constructor: Team,

    init: function(){
        var proto = this;
        proto.sizeMembers();
        $(window).resize(proto.sizeMembers);
        $(".team__member").on('click', function(e){
            e.preventDefault();
            $(".team__member").removeClass('hovered');
            $(this).addClass('hovered');
        });
    },
    sizeMembers: function(){
        $(".team__member").height($(".team__member").width());
    }

};

app.modules.team = new Team;




function PageLoader() {
};

PageLoader.prototype = {
    constructor: PageLoader,

    /*
    Checking the path: If it's the mainpage, then the page is displayed instantly without the preloader.
     */
    init: function(){
        var proto = this;
        if(!(location.pathname == "/" || location.pathname == "" || location.pathname == "/de/" || location.pathname == "/de")){
            $(".preloader").css("display","block").css("opacity",1);
            $(".container").addClass("down");

            if(Modernizr.cssanimations){
                $(".preloader .progress").css("display","block");
            }
            else {
                $(".preloader .loadinggif").css("display","block");
            }
            proto.load();
        }
        else {
            proto.load();
        }
    },
    closePreloader: function(){
        if(Modernizr.cssanimations){
            $(".preloader").addClass("animated");
            $(".container").removeClass("down");
            setTimeout(function(){
                $(".preloader").remove();
            },1000);
        }
        else {
            $(".container").removeClass("down");
            $(".preloader").remove();
        }
    },
    load: function ()  {

        var proto = this;

        var requests = [];

        $("*[data-url]").each(function(){
            var section = $(this);
            requests.push(proto.loadPage($(this).attr("data-url")).done(function(data){
                var temp = $(data);
                var content = temp.find("#"+section.attr("id"));
                content.children().appendTo(section);
            }));
        });
        if($(".header__menu").length > 0){
            app.modules.navigation.placeHamburger();
            $(".header__menu, .header__head__inner").css("opacity",1);
        }
        $.when.apply($,requests).then(function(){ // When all AJAX-Requests are done

            $.when(app.init()).done(function() { // When all the init-Functions of the modules are done
                app.modules.projects.initTabs();
                var scrollto = $("*[scrollto=true]");

                if(scrollto.length) {
                    $('html, body').animate({
                        scrollTop: $("*[scrollto=true]").offset().top-50-parseInt($(".container").css("margin-top"))
                    }, 0, function () {
                        proto.closePreloader();
                    });
                }
                else {
                    proto.closePreloader();
                }
            });
        },function(){
            proto.closePreloader();
        });
    },
    loadPage: function(page) {
        var proto = this;
        return $.ajax({
            url: page,
            method: "POST"
        }).done(function(){
        });
    },
    goToProject: function(friendlyurl){ // Scrolling down to the section
        app.modules.projects.loadProject(friendlyurl);
        app.modules.navigation.goTo("projects");
    }
};

app.modules.pageLoader = new PageLoader;
function ScrollController() {
};

ScrollController.prototype = {
    constructor: ScrollController,

    init: function() {
        if(window.addEventListener) {
            this.initHeader();
        }
    },
    initHeader: function() {
        var controller = null;
        var sceneParallax = null;

        var images = [];

        $("#headergallery > div").each(function(){
            images.push({src: $(this).attr("data-src")});
        });


        $("#header").vegas({
            slides: images,
            timer: false,
            walk: function(index, slideSettings) {
                if (!Modernizr.touch) {
                    if (controller) {
                        controller.destroy(true);
                        controller = null;
                        sceneParallax.destroy(true);
                        sceneParallax = null;
                    }
                    controller = new ScrollMagic.Controller();

                    var tweenPrallax = TweenMax.to(".vegas-slide:not(.vegas-transition-fade-out) .vegas-slide-inner", 1, {
                        top: Math.ceil($("#header").outerHeight() / 4)
                    });



                    sceneParallax = new ScrollMagic.Scene({
                        triggerElement: "#header",
                        triggerHook: 0,
                        duration: $("#header").outerHeight()
                    })
                        .setTween(tweenPrallax)
                        .addTo(controller);

                    var tweenFade = TweenMax.to(".header__content", 1, {
                        opacity: 0
                    });

                    var sceneFade = new ScrollMagic.Scene({
                        triggerElement: "#header",
                        triggerHook: 0,
                        duration: $("#header").outerHeight()/2,
                        offset: $("#header").outerHeight()/2
                    })
                        .setTween(tweenFade)
                        .addTo(controller);

                    var tweenWhiteHeader = TweenMax.to(".header__overlay", 1, {
                        backgroundColor: "rgba(255,255,255,0.9)"
                    });

                    var sceneWhiteHeader = new ScrollMagic.Scene({
                        triggerElement: "#header",
                        triggerHook: 0,
                        duration: $("#header").outerHeight()/2,
                        offset: $("#header").outerHeight()/2
                    })
                        .setTween(tweenWhiteHeader)
                        .addTo(controller);
                }
            }
        });
    }
};

app.modules.scrollController = new ScrollController;
app.modules.blog = new function Blog() {
	this.modal = null;

	this.init = function() {
		this.bind();
	};

	this.bind = function() {
		var self = this;

		$( '.js-blog-read-more' ).off( 'click' ).on( 'click', function( event ) {
			event.preventDefault();
			var postId = $( this ).attr( 'data-post-id' ) || null;
			self.openModal( postId );
		});
	};

	this.openModal = function( postId ) {
		if ( this.modal ) {
			this.modal = null;
		}
		this.modal = new BlogModal( postId );
	};

	this.init();
};




function BlogModal( postId ) {
	this.postId = postId;
	this.root = $( '.js-blog-modal' );
	this.postContainer = $( '.js-blog-container', this.root );
	this.postContent = $( '.js-blog-content', this.root );
	this.isLoading = false;

	this.init = function() {
		this.bind();
		this.openModal();
		//this.update( this.postId );
	};

	this.bind = function() {
		var self = this;

		$( '.js-blog-modal-close' ).off( 'click' ).on( 'click', function( event ) {
			event.preventDefault();
			if ( self.isLoading ) return;
			self.closeModal();
		});

		$( '.js-blog-modal-prev' ).off( 'click' ).on( 'click', function( event ) {
			event.preventDefault();
			if ( self.isLoading ) return;
			var newId = -1;
			self.update( newId );
		});

		$( '.js-blog-modal-next' ).off( 'click' ).on( 'click', function( event ) {
			event.preventDefault();
			if ( self.isLoading ) return;
			var newId = +1;
			self.update( newId );
		});
	};

	this.update = function( postId ) {
		this.postId = postId;
		var self = this;

		this.hidePostContent( function() {
			self.loadNewPost();
		});
	};

	this.showPostContent = function( callback ) {
		var self = this;
		$( '.js-blog-modal' ).scrollTop( 0 );
		TweenLite.to( self.postContainer, 0.5, {
			opacity: 1,
			onComplete: callback
		});
	};

	this.hidePostContent = function( callback ) {
		var self = this;
		TweenLite.to( self.postContainer, 0.5, {
			opacity: 0,
			onComplete: callback
		});
	};

	this.openModal = function() {
		var self = this;
		// Disable body scrolling
		$( 'body' ).css({
			'overflow-y': 'hidden',
			'padding-right': getScrollBarWidth() + 'px'
		});

		TweenLite.to( self.root, 0.5, {
			display: 'block',
			opacity: 1
		});
	};

	this.closeModal = function() {

		var self = this;
		TweenLite.to( self.root, 0.5, {
			display: 'none',
			opacity: 0,
			onComplete: function() {
				self.postId = null;
				self.postContent.empty();

				// Restore body scrolling
				$( 'body' ).css({
					'overflow-y': 'scroll',
					'padding-right': '0'
				});
			}
		});
	};

	this.loadNewPost = function() {
		this.isLoading = true; // Will lock UI buttons

		var self = this;
		$.ajax({
			url: 'https://baconipsum.com/api/?type=meat-and-filler&paras='+ (Math.random() * 5 + 3).toFixed() +'&format=html',
			method: 'get',
			dataType: 'html',
			success: function( response ) {
				//console.log( 'POST LOAD SUCCESS', response );
				self.postContent.html( '<h1>Very tasty blog post.</h1>' + response );
				self.showPostContent( function() {
					self.isLoading = false;
				});
			},
			error: function( error ) {
				//console.log( 'POST LOAD ERROR', error );
				self.isLoading = false;
			}
		});
	}

	this.init();
};







// Utility function to calculate scrollbar width
// https://gist.github.com/kflorence/3086552
function getScrollBarWidth() {
	var inner = document.createElement('p');
	inner.style.width = "100%";
	inner.style.height = "200px";

	var outer = document.createElement('div');
	outer.style.position = "absolute";
	outer.style.top = "0px";
	outer.style.left = "0px";
	outer.style.visibility = "hidden";
	outer.style.width = "200px";
	outer.style.height = "150px";
	outer.style.overflow = "hidden";
	outer.appendChild(inner);

	document.body.appendChild(outer);
	var w1 = inner.offsetWidth;
	outer.style.overflow = 'scroll';
	var w2 = inner.offsetWidth;

	if (w1 == w2) {
		w2 = outer.clientWidth;
	}

	document.body.removeChild(outer);

	return (w1 - w2);
}

function pad(s) { return (s < 10) ? '0' + s : s; }

function createHtmlNode(value, index, ar) {
	htmlNode = $('#small-blog-entries').children(':last').clone();
	htmlNode.find('h1').text(value.blog_entry_title);
	htmlNode.find('.summary-text').replaceWith(value.blog_entry_text);
	image = JSON.parse(value.blog_entry_image);
	htmlNode.find('img').attr('src', image.version0);
	creationTimestamp = parseInt(value.creation)*1000;
	time = new Date(creationTimestamp);
	creationDate = pad(time.getDate())+'.'+pad(time.getMonth()+1)+'.'+time.getFullYear();
	htmlNode.find('.summary-date').text(creationDate);
	htmlNode.appendTo($('#small-blog-entries'));
	if (index == 3) {
		window.stopLoad = false;
	}
}

$(document).on('click', '#load_more_blog', function(event) {
	var loadBtn = $(this);
	event.preventDefault();
	$.get( $(this).attr('href')+'/3/'+$(this).attr('data-offset'), function(data) {
		parsedData = JSON.parse(data);

		window.stopLoad = true;
		console.log(parsedData.data.length);

		if (parsedData.data.length < 3){
			loadBtn.hide();
		}

		parsedData.data.forEach(createHtmlNode);
	} );
	newOffset = parseInt($(this).attr('data-offset'));
	$(this).attr('data-offset', newOffset+3);
});


